import { SITE, TEXT_2_AUDIO_IMAGE } from '@/app/constants';
import type { CreationDetailThumbScrollListProps } from '@/app/types';
import { getAudioImageIndex } from '@/app/utils';
import type { FileItem } from '../types';

type ThumbListItem = NonNullable<CreationDetailThumbScrollListProps['list']>[number];

/**
 * 从当前文件列表生成 creation-detail 右侧缩略图列表（仅保留作品，跳过文件夹）
 */
export function buildCreationDetailThumbListFromFiles(files: FileItem[]): ThumbListItem[] {
  return files
    .filter((item) => item.type === 'creation' && !!item.creationId)
    .map((item) => ({
      id: item.creationId || '',
      cover_uri:
        item.creationType === 'audio'
          ? TEXT_2_AUDIO_IMAGE[getAudioImageIndex(item.creationId || item.id, TEXT_2_AUDIO_IMAGE.length)].cover[SITE]
          : (item.coverUrl ?? ''),
      is_favor: item.is_favorite ?? false,
      origin_task_type: item.creationType,
    }));
}
